/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const toolboxXML = `<xml>
<toolboxlabel name="Build workflows"></toolboxlabel>
    <category name="Input" categorystyle="input_category">
        <category name="Imagery" categorystyle="input_category">
            <block type="input_optical_data"></block>
            <block type="input_radar_data"></block>
        </category>

        <category name="Terrain" categorystyle="input_category">
            <block type="input_dem_data"></block>
        </category>

        <category name="Atmosphere" categorystyle="input_category">
            <block type="input_precipitation_data"></block>
            <block type="input_atmospheric_data"></block>
            <block type="input_climate_data"></block>
        </category>

        <category name="Anthropogenic" categorystyle="input_category">
            <block type="input_anthropogenic"></block>
        </category>

        <category name="Landcover" categorystyle="input_category">
            <block type="input_land_cover"></block>
            <block type="input_ice_data" ></block>
        </category>

        <category name="Forest" categorystyle="input_category">
            <block type="input_hansen_forest_change"></block>
            <block type="input_forest_data"></block>
        </category>

        <category name="Water" categorystyle="input_category">
            <block type="input_water_data" ></block>
        </category>

        <category name="Fires and Droughts" categorystyle="input_category">
            <block type="input_fire_data" disabled="false"></block>
            <block type="input_drought_data" disabled="false"></block>
        </category>

        <category name="Data Selector" toolboxitemid="input.data_selector" categorystyle="input_category">
            <block type="input_data_selector"></block>
        </category>
    </category>

    <category name="Analyse" categorystyle="analyse_category">

        <category name="Comparison" categorystyle="analyse_category">
            <block type="analyse_fires_to_land_comparison"></block>
        </category>

        <category name="Time Series" categorystyle="analyse_category">
            <block type="analyse_timeseries"></block>
        </category>

        <category name="Indices" categorystyle="analyse_category">
            <block type="analyse_ndvi"></block>
            <block type="analyse_ndwi"></block>
            <block type="analyse_ndsi"></block>
            <block type="analyse_nbi"></block>
            <block type="analyse_spi"></block>
        </category>

        <category name="Band Math" categorystyle="disabled_category">
            <block type="analyse_band_math" disabled="true">
            </block>

            <block type="analyse_single_band_math" disabled="true">
            </block>

            <block type="analyse_math_arithmetic_overriden" disabled="true">
                <field name="OP">ADD</field>
                <value name="A">
                </value>
                <value name="B">
                </value>
            </block>

            <block type="analyse_band_input" disabled="true"></block>

            <block type="analyse_math_number_overriden" disabled="true">
                <field name="NUM">0</field>
            </block>

            <block type="analyse_math_single_overriden" disabled="true">
                <field name="OP">ROOT</field>
                <value name="NUM">
                </value>
            </block>

            <block type="analyse_math_trig_overriden" disabled="true">
                <field name="OP">SIN</field>
                <value name="NUM">
                </value>
            </block>
            <block type="analyse_math_constant_overriden" disabled="true">
                <field name="CONSTANT">PI</field>
            </block>
        </category>

        <category name="Classification" categorystyle="disabled_category">
            <block type="analyse_unsupervised_classification" disabled="true"></block>
            <block type="analyse_supervised_classification" disabled="true"></block>
            <block type="analyse_supervised_class_selector" disabled="true"></block>
        </category>

</category>

    <category name="Output" categorystyle="output_category">
        <category name="Map visualisation" categorystyle="output_category">
            <block type="output_optical_vis">
            <field name="bandR">r</field>
            <field name="bandG">g</field>
            <field name="bandB">b</field>
            </block>
            <block type="output_radar_vis"></block>
            <block type="output_dem_vis"></block>
            <block type="output_other_vis"></block>
        </category>

        <category name="Download" categorystyle="output_category">
            <block type="output_download"></block>
        </category>

        <category name="Dashboards" categorystyle="disabled_category">
            <block type="output_charts" disabled="true"></block>
            <block type="output_table" disabled="true"></block>
            <block type="output_band_histogram" disabled="true">
                <value name="y_input">
                    <shadow type="input_scatter_y_band">
                    </shadow>
                </value>
            </block>
        </category>
    </category>
</xml>`;

const toolboxXML_noDownload = `<xml>
<toolboxlabel name="Build workflows"></toolboxlabel>
    <category name="Input" categorystyle="input_category">
        <category name="Imagery" categorystyle="input_category">
            <block type="input_optical_data"></block>
            <block type="input_radar_data"></block>
        </category>

        <category name="Terrain" categorystyle="input_category">
            <block type="input_dem_data"></block>
        </category>

        <category name="Atmosphere" categorystyle="input_category">
            <block type="input_precipitation_data"></block>
            <block type="input_atmospheric_data"></block>
            <block type="input_climate_data"></block>
        </category>

        <category name="Anthropogenic" categorystyle="input_category">
            <block type="input_anthropogenic"></block>
        </category>

        <category name="Landcover" categorystyle="input_category">
            <block type="input_land_cover"></block>
            <block type="input_ice_data" ></block>
        </category>

        <category name="Forest" categorystyle="input_category">
            <block type="input_hansen_forest_change"></block>
            <block type="input_forest_data"></block>
        </category>

        <category name="Water" categorystyle="input_category">
            <block type="input_water_data" ></block>
        </category>

        <category name="Fires and Droughts" categorystyle="input_category">
            <block type="input_fire_data" disabled="false"></block>
            <block type="input_drought_data" disabled="false"></block>
        </category>
        
        <category name="Data Selector" toolboxitemid="input.data_selector" categorystyle="input_category">
            <block type="input_data_selector"></block>
        </category>
    </category>

    <category name="Analyse" categorystyle="analyse_category">

        <category name="Comparison" categorystyle="analyse_category">
            <block type="analyse_fires_to_land_comparison"></block>
        </category>

        <category name="Time Series" categorystyle="analyse_category">
            <block type="analyse_timeseries"></block>
        </category>

        <category name="Indices" categorystyle="analyse_category">
            <block type="analyse_ndvi"></block>
            <block type="analyse_ndwi"></block>
            <block type="analyse_ndsi"></block>
            <block type="analyse_nbi"></block>
            <block type="analyse_spi"></block>
        </category>

        <category name="Band Math" categorystyle="disabled_category">
            <block type="analyse_band_math" disabled="true">
            </block>

            <block type="analyse_single_band_math" disabled="true">
            </block>

            <block type="analyse_math_arithmetic_overriden" disabled="true">
                <field name="OP">ADD</field>
                <value name="A">
                </value>
                <value name="B">
                </value>
            </block>

            <block type="analyse_band_input" disabled="true"></block>

            <block type="analyse_math_number_overriden" disabled="true">
                <field name="NUM">0</field>
            </block>

            <block type="analyse_math_single_overriden" disabled="true">
                <field name="OP">ROOT</field>
                <value name="NUM">
                </value>
            </block>

            <block type="analyse_math_trig_overriden" disabled="true">
                <field name="OP">SIN</field>
                <value name="NUM">
                </value>
            </block>
            <block type="analyse_math_constant_overriden" disabled="true">
                <field name="CONSTANT">PI</field>
            </block>
        </category>

        <category name="Classification" categorystyle="disabled_category">
            <block type="analyse_unsupervised_classification" disabled="true"></block>
            <block type="analyse_supervised_classification" disabled="true"></block>
            <block type="analyse_supervised_class_selector" disabled="true"></block>
        </category>

</category>

    <category name="Output" categorystyle="output_category">
        <category name="Map visualisation" categorystyle="output_category">
            <block type="output_optical_vis">
            <field name="bandR">r</field>
            <field name="bandG">g</field>
            <field name="bandB">b</field>
            </block>
            <block type="output_radar_vis"></block>
            <block type="output_dem_vis"></block>
            <block type="output_other_vis"></block>
        </category>

        <category name="Download" categorystyle="disabled_category">
            <block type="output_download" disabled="true"></block>
        </category>

        <category name="Dashboards" categorystyle="disabled_category">
            <block type="output_charts" disabled="true"></block>
            <block type="output_table" disabled="true"></block>
            <block type="output_band_histogram" disabled="true">
                <value name="y_input">
                    <shadow type="input_scatter_y_band">
                    </shadow>
                </value>
            </block>
        </category>
    </category>
</xml>`;

export { toolboxXML, toolboxXML_noDownload };
